<template>
  <el-dialog
    title="广告"
    v-if="DialogVisible"
    :visible.sync="DialogVisible"
    width="750px"
    class="large-padding-dialog"
    :close-on-click-modal="false"
    :before-close="Hide"
  >
    <el-form
      :model="DialogFormData"
      ref="DialogFormData"
      :rules="dialogRules"
      :class="[{ View: Type == 'View' }]"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-row>
            <el-form-item label="广告位置" prop="position">
              <el-select v-model="DialogFormData.position" clearable>
                <el-option
                  v-for="item in positionList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>

          <el-row style="text-align: center">
            <ResourceUpLoad
              label="图片"
              prop="url"
              usage="banner"
              :initResourceUrl.sync="DialogFormData.url"
              :disabled="Type == 'View'"
            />
          </el-row>

          <el-row>
            <el-form-item label="优先级" prop="order_index">
              <el-input-number
                v-model="DialogFormData.order_index"
                :step="1"
                step-strictly
              ></el-input-number>
            </el-form-item>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <el-checkbox v-model="DialogFormData.show_pc"
              >电脑端可见</el-checkbox
            >
            <el-input
              v-if="DialogFormData.show_pc"
              v-model="DialogFormData.path_pc"
              placeholder="电脑端跳转路径"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-checkbox v-model="DialogFormData.show_app"
              >手机端可见</el-checkbox
            >
            <el-input
              v-if="DialogFormData.show_app"
              v-model="DialogFormData.path_app"
              placeholder="手机端跳转路径"
            ></el-input>
          </el-form-item>

          <el-form-item label="开始时间（精确到小时）">
            <el-date-picker
              v-model="DialogFormData.start_time"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="结束时间（精确到小时）">
            <el-date-picker
              v-model="DialogFormData.end_time"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="Hide">{{l("取 消")}}</el-button>
      <el-button v-if="Type == 'View'" type="warning" @click="Type = 'Edit'"
        >{{l("修 改")}}</el-button
      >
      <el-button
        v-if="Type == 'Create' || Type == 'Edit'"
        type="primary"
        @click="submitForm"
        >{{l("确 定")}}</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import dialogMixin from "@/assets/js/dialogMixin";

export default {
  name: "CreateOrEditBanner",
  mixins: [dialogMixin],
  props: ["positionList"],
  data() {
    return {
      DialogFormData: {
        id: "",
        position: "",
        url: "",
        show_pc: false,
        show_app: false,
        path_pc: "",
        path_app: "",
        order_index: 0,
        start_time: null,
        end_time: null,
      },
      dialogRules: {
        position: [{ required: true, message: "请选择位置", trigger: "blur" }],
        order_index: [
          { required: true, message: "请选择优先级", trigger: "blur" },
        ],
        url: [{ required: true, message: "请上传广告图", trigger: "blur" }],
      },
    };
  },
  methods: {
    submitForm() {
      this.$refs["DialogFormData"].validate((valid, obj) => {
        if (!valid) {
          return this.$message.error(obj[Object.keys(obj)[0]][0].message);
        }
        console.log("DialogFormData", this.DialogFormData);

        if (this.Type == "Create") {
          this.axios
            .post(`/api/admin_banner/`, this.DialogFormData)
            .then((data) => {
              this.$emit("submitDialog");
              this.Hide();
            });
        } else {
          this.axios
            .put(
              `/api/admin_banner/${this.DialogFormData.id}/`,
              this.DialogFormData
            )
            .then((data) => {
              this.$emit("submitDialog");
              this.Hide();
            });
        }
      });
    },
  },
};
</script>


<style scoped lang="scss">
</style>

